module.exports = __webpack_public_path__ + "assets/img/icon_user18.ed932317.png";